import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { userLearningPathsReselector as stateSelector } from 'reduxModules/users/selectors'
import { learningPathsDispatchers as dispatchSelector } from 'reduxModules/users/dispatchers'
import LearningPath from './LearningPath'

export class LearningPaths extends Component {
  componentDidMount() {
    this.props.loadUserLearningPaths()
  }

  render() {
    if (!this.props.learningPaths) return null
    return (
      <div id="LearningPaths" className="account-section">
        <h3 className="account-section__title">Learning Pathways</h3>
        {!_.isEmpty(this.props.learningPaths) && (
          <div className="content-list">
            {this.props.learningPaths.map((path, pathIndex) => (
              <LearningPath key={pathIndex} {...path} />
            ))}
          </div>
        )}
        {_.isEmpty(this.props.learningPaths) && (
          <div className="no-results">
            <span>You haven't taken any learning pathway yet.</span>
          </div>
        )}
      </div>
    )
  }
}

LearningPaths.propTypes = {
  loadUserLearningPaths: PropTypes.func.isRequired,
  learningPaths: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.number.isRequired
}

LearningPaths.defaultProps = {
  learningPaths: []
}

export default connect(stateSelector, dispatchSelector)(LearningPaths)
